import { useMutation } from '@gogame/query';

import { exportTable } from 'scenes/AuditLogs/sources/auditLogs';

import { exportAuditLogs } from '../queryKeyFactory';

export const useExportTable = () => {
  const exportMutations = useMutation(exportAuditLogs(), exportTable);

  return [exportMutations.mutateAsync, exportMutations];
};
